import React, { useState } from 'react';
import styled from 'styled-components';
import Menu from '../UI/Menu';
import MenuIconWrapper from '../UI/MenuIconWrapper';
import { BG, MAIN_YELLOW } from '../../styles/color';
import logo from '../../assets/logo/logo_grayscale.svg';
import { Link } from 'react-router-dom';

const Nav = styled.nav`
    height: 110px;
    width: 100%;
    min-width: 1080px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 15px 30px 10px 30px;
    background-color: ${BG.deep02};
    position: relative;
    box-sizing: border-box;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
`;

const MenuWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 30px;
`;

const LogoWrapper = styled.div`
    display: inline-block;
`;

export default function Navigation() {
    const [isHovered, setIsHovered] = useState(false);
    
    return (
        <Nav $isHovered={isHovered}>
            <MenuWrapper>
                <LogoWrapper>
                    <Link to="/">
                        <img src={logo} style={{width: 170 + "px"}}/>
                    </Link>
                </LogoWrapper>
                <Menu
                    isHovered={isHovered}
                    setIsHovered={setIsHovered}
                ></Menu>
                <MenuIconWrapper 
                    style ={{ position: 'absolute', bottom: 10 + 'px', right: 50 + 'px' }}
                />
            </MenuWrapper>
        </Nav>
    );
};